export default {"src":"/_next/static/media/close.4d20c66b.svg","height":33,"width":33};